import {Component, Input, OnInit} from '@angular/core';
import { SelectComponent } from '../../../core/components/edit-component';
import {UserModel, UserQuery} from 'common-shared';
import { UserEditModalComponent } from '../user-edit-modal/user-edit-modal.component';
import {UserService} from "../user.service";
import {combineLatest, map, takeUntil} from "rxjs";
import {RoleService} from "../../role/role.service";
@Component({
  selector: 'mes-user-select',
  templateUrl: './user-select.component.html',
  styleUrls: ['./user-select.component.scss']
})
export class UserSelectComponent extends SelectComponent<UserQuery> implements OnInit {
  @Input() groupByRole = false;

  constructor(private userService: UserService, private roleService: RoleService) {
    super();
  }

  ngOnInit() {
    this.refreshToken$.next(undefined);

    if (this.groupByRole) {
      this.allItems$ = this.getUsersGroupedByRole() as any;
    }
  }

  addNewUser(searchTerm: string = null) {
    const data = { initialState: { entityName: searchTerm } };
    this.startEdit(data);
  }

  editUser() {
    const data = { initialState: { entityId: this.entityId } };
    this.startEdit(data);
  }

  startEdit(data) {
    this.modalService
    .show(UserEditModalComponent, data).content.onHide$.pipe(takeUntil(this.componentDestroyed))
    .subscribe(({data}) => {
      this.refreshToken$.next(undefined);
      this.setEntityId(data);
    });
  }

  private getUsersGroupedByRole() {
    return combineLatest([this.roleService.$getAll, this.userService.getWithRoles()]).pipe(map(([roles, users]) => {
      let usersByRoles: { Role: string, Users: UserModel[] }[] = [];
      roles.forEach(role => {
        const usersInRole = users.filter(user => user.RoleIds.some(roleId => roleId === role.Id));
        usersByRoles.push({Role: role.Name, Users: usersInRole});
      });
      return usersByRoles.filter(role => role.Users?.length);
    }), takeUntil(this.componentDestroyed));
  }

  onSelectionChanged($event: UserQuery[] | UserQuery) {
    if (this.multiple) {
      const users = $event as UserQuery[];
      if (users && users.length) {
        this.entityIdsChange.emit(users.map(value => value.Id));
      } else {
        this.entityIdsChange.emit([]);
      }
    } else {
      this.setEntityId(($event as UserQuery)?.Id);
    }
  }
}
